import axiosInstance from '../../../api/axios';
import {
  iMostraSeuAprovaState,
  iRegisterViewPayload,
  iRegisterViewResponse,
} from './campaign';

/** Janela, status de inscrição e o que o aluno já viu. */
export async function getMostraSeuAprovaState(): Promise<iMostraSeuAprovaState> {
  const response = await axiosInstance.get('/mostra-seu-aprova/state');

  return response.data;
}

/**
 * Registra a exibição de um modal e devolve o estado já atualizado.
 *
 * É o servidor quem aloca o slot e revalida janela, status e prazo — por isso a
 * chamada acontece ANTES de abrir o modal, e não no fechamento: se a resposta
 * vier com `registered: false`, o modal não deve aparecer. Também é o que
 * resolve duas abas disparando um gatilho ao mesmo tempo.
 */
export async function postMostraSeuAprovaView(
  payload: iRegisterViewPayload
): Promise<iRegisterViewResponse> {
  const response = await axiosInstance.post('/mostra-seu-aprova/view', payload);

  return response.data;
}
